import { cn } from '@client/lib';
import { formatCurrency } from '@shared';

interface MetricCardProps {
  title: string;
  amount: number;
  subtitle: string;
  className?: string;
}

export function MetricCard({ title, amount, subtitle, className }: MetricCardProps) {
  return (
    <div className="rounded-2xl border bg-white p-6 shadow-sm">
      <h3 className="mb-2 text-sm text-gray-700">{title}</h3>
      <p className={cn('mb-2 font-sans text-3xl font-bold text-gray-900', className)}>
        {formatCurrency(amount)}
      </p>
      <p className="text-sm text-gray-700">{subtitle}</p>
    </div>
  );
}
